/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecondaryMaterialBlock } from '../../models/secondary-material-block';

export interface GetMountedMaterials2$Params {
  workCenterId: number;
}

export function getMountedMaterials2(http: HttpClient, rootUrl: string, params: GetMountedMaterials2$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecondaryMaterialBlock>>> {
  const rb = new RequestBuilder(rootUrl, getMountedMaterials2.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SecondaryMaterialBlock>>;
    })
  );
}

getMountedMaterials2.PATH = '/api/v1/SecondaryMaterial/{workCenterId}/MountedMaterials';
